export default __webpack_public_path__ + "static/web-logo-4-5b2e41a750c383193786978ed9016b08.webp";